import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

import Container, { Row, Third, Half, TwoThird, Full } from "../layout/container"
import Sidemenu from "../layout/sidebar";
import VisitingSidemenu from "../layout/sidebar-visiting";

const Section = styled.section`
  background: ${(props) => props.theme.colors.white};
  padding: 3rem 0 3rem;
  h2 {
    //font-family: ${(props) => props.theme.fontBold};
    position: relative;
    text-transform: uppercase;
    margin-bottom: 0;
  }
  aside {
    display: none;
    .future {
        opacity: 1;
    }
    .proposal {
        opacity: 0.5;
    }
    .collab {
        opacity: 0.5;
    }
    .about {
        opacity: 0.5;
    }
    .feedback {
        opacity: 0.5;
    }
    @media screen and (min-width: ${props => props.theme.breakpoints.tablet}) {
      display: block;
    }
  }
`;



const Button = styled(Link)`
    font-size: 1rem;
    padding: 1rem 0;
    text-align: center;
    margin: 1rem 0;
    border: 2px solid #00FFB4;
    color: #3C3C3B;
    -webkit-text-decoration: none;
    text-decoration: none;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    z-index: 3;
    position: relative;
    width: 100%;
  &:hover {
    background: transparent;
    border: 2px solid ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.white};
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding: 0.5rem 2rem;
    font-size: 1.5rem;
  }
`

const ImageBlock = styled.div`
  padding: 2rem 0;
`

const Credit = styled.div`
  padding-left: 1rem;
  @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
    padding-left: 0;
    padding-top: 1rem;
  }
  p {
    font-size: 0.6rem;
    padding-bottom: 0.2rem;
    margin: 0;
  }
`

const Banner = styled.div`
    .alert {
        display: flex;
        background-color: #EED0C7;
        justify-content: space-between;
        &.hide {
            display-none;
        }
        p {
            padding: 0.5rem 0 0.5rem 1rem;
            margin: 0;
        }
        span {
            padding: 0.5rem 1rem 0.5rem 0;
        }
    }
  
`

  const AddressBlock = styled.ul`
        font-family: ${(props) => props.theme.fontCondensed};
        margin: 0;
        display: inline-block;
        padding: 0;
        li {
          :first-child {
            font-size: 0.6rem;
            padding-bottom: 0.5rem;
          }
          list-style: none;
        }
        .opening {
          -webkit-user-modify: read-write-plaintext-only;
        }
  `






const Address = () => {
    const data = useStaticQuery(graphql`{
          contentfulOpeningTimes {
            openingTimes {
              openingTimes
            }
          }
  file(relativePath: {eq: "market-arch.jpeg"}) {
    childImageSharp {
      gatsbyImageData(width: 700, layout: CONSTRAINED)
    }
  }
}
`)
    const [showText, setShowText] = useState(false);
    const onClick = () => setShowText(false);
  return (
    <Section id="plan-your-visit">
            <h2>
              PLAN YOUR VISIT
            </h2>
            <Banner>
                {showText ? <div className="alert">
                    <p>*The market is currently partially closed. Read the latest update <a href="">here</a></p>
                    <span onClick={onClick}>Hide</span>
                </div> : null}
  
            </Banner>
            <Row>
                <Half>
                    <AddressBlock>
                        <li>GETTING HERE</li>
                        <li>Shepherd’s Bush Market</li>
                        <li>Uxbridge Road</li>
                        <li>Shepherd’s Bush</li>
                        <li>London W12 8DF</li>
                        <li><a href="https://goo.gl/maps/hgb6n9ZhbY7d8pCK9" target="_blank" className="underline">View on Google Maps</a></li>
                        <br/>
                        <li>Entrances on Uxbridge Road</li>
                        <li>and Goldhawk Road</li>
                    </AddressBlock>
                </Half>
                <Half>
                    <AddressBlock>
                        <li>OPENING TIMES</li>
                        <li className="opening">{data.contentfulOpeningTimes.openingTimes.openingTimes}</li>
                        <br />
                        <li>See hours for</li>
                        <li><Link to="/trader-directory">individual shops</Link></li>
                    </AddressBlock>
                </Half>
            </Row>
            
            
            <ImageBlock>
                <Row>
                    <Full>
                        <GatsbyImage image={data.file.childImageSharp.gatsbyImageData} /> 
                    </Full>
                </Row>
            </ImageBlock>
            
            
    </Section>
  );
};

export default Address;